module.exports = __webpack_public_path__ + "static/media/gas2.f897912e.mp4";